// Public contact info for the Evolve2Digital attribution. Not sensitive, so the
// REACT_APP_* overrides ship in the bundle (CLAUDE.md G8) — that is intentional.
export const PHONE_FALLBACK = '34605497639';
export const EMAIL_FALLBACK = 'hello@evolve2digital.com';

export function getE2DEmail() {
  return process.env.REACT_APP_E2D_EMAIL || EMAIL_FALLBACK;
}

export function buildE2DWhatsAppUrl(message) {
  const phone = (process.env.REACT_APP_E2D_WHATSAPP || PHONE_FALLBACK).replace(/\D/g, '');
  const text = message || "Hi! I'm reaching out from abyfoods.fi — I'd love to talk about a project.";
  return `https://wa.me/${phone}?text=${encodeURIComponent(text)}`;
}
